import { Fragment } from "react";
import { Link } from "react-router";
import { ChevronIcon } from "../../lib/RowDisclosure.tsx";

/**
 * Крошки шапки экрана: путь до вложенного экрана и его собственное имя
 * последним.
 *
 * ⚠️ **Живут ВНУТРИ шапки, первой строкой**, а не абзацем над ней. До
 * 14.09.2026 их писал руками каждый вложенный экран, и выходило четыре разные
 * крошки: где-то `<p className="muted">` с косой чертой, где-то без ссылки
 * вовсе, а на двух экранах роль крошки играла кнопка «В материалы» в правом
 * конце строки заголовка, то есть навигация занимала место главного действия.
 *
 * Разделитель это шеврон, а не косая черта, и берётся он тем же значком, что
 * раскрывает строку списка (`ChevronIcon`): фигура «дальше вправо» в продукте
 * одна.
 *
 * ⚠️ Ссылками, а не кнопкой «назад»: это переходы по адресам, и их обязано быть
 * видно в строке браузера и можно открыть в новой вкладке. Кнопка «назад» самого
 * браузера при этом работает сама, потому что у каждого экрана есть свой адрес.
 *
 * ⚠️ Последний шаг НЕ ссылка: она вела бы на тот же адрес, на котором человек
 * стоит. Читалке путь назван словом через `aria-label`, потому что шеврон для
 * неё это пустой узел.
 */
export function Crumbs(props: {
  /** Предки, от корня раздела к ближайшему. */
  trail: readonly { label: string; to: string }[];
  /**
   * Имя текущего экрана.
   *
   * ⚠️ `null` означает «звена нет вовсе», а не «показать многоточие». Так решено
   * на экране расписания группы: там эта ветка рисует «такой группы нет», и
   * многоточие обещало бы название, которого не будет. Пока имя едет с сервера,
   * экран передаёт сюда своё «…» сам, если ему нужно держать высоту строки.
   */
  here: string | null;
}) {
  return (
    <nav className="head__crumbs" aria-label="Где я">
      {props.trail.map((step, i) => (
        <Fragment key={step.to}>
          {i > 0 && <ChevronIcon />}
          <Link className="textlink" to={step.to}>
            {step.label}
          </Link>
        </Fragment>
      ))}
      {props.here !== null && (
        <>
          {props.trail.length > 0 && <ChevronIcon />}
          <span>{props.here}</span>
        </>
      )}
    </nav>
  );
}
